import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { type RefObject, useRef } from "react";

interface UseStickyAnimationProps {
	elRef: RefObject<HTMLElement>;
	isEmpty: boolean;
}

function useStickyAnimation({ elRef, isEmpty }: UseStickyAnimationProps) {
	const wasVisible = useRef(!isEmpty);

	useGSAP(
		() => {
			const nowVisible = !isEmpty;

			if (wasVisible.current && !nowVisible) {
				// disappearing
				gsap.to(elRef.current, { autoAlpha: 0, duration: 0.3, ease: "power1.out" });
			} else if (!wasVisible.current && nowVisible) {
				// appearing
				gsap.fromTo(elRef.current, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3, ease: "power1.in" });
			} else if (!nowVisible) {
				// ensure it's hidden on initial render if empty
				gsap.set(elRef.current, { autoAlpha: 0 });
			}

			wasVisible.current = nowVisible;
		},
		{ scope: elRef, dependencies: [isEmpty] },
	);
}

export default useStickyAnimation;
